const DefaultErrorMessages = [
  //
  // The following rule will match every message path, behaving
  // like the default sink if a path is not found.
  //
  // Remember to concat these error messages when you are composing
  // your own at a higher level. For example:
  //
  // const PathCustomizations = [
  //  {
  //    path: /^id$/,
  //    type: 'PROP_MISSING',
  //    message: 'Please specify an ID'
  //  }
  //  'id': {
  //    PROP_MISSING: 'Please specify an ID'
  //   },
  //  'container.[^.]+.id': {
  //    PROP_MISSING: 'Please specify an ID for this container'
  //   }
  // ].concat(DefaultErrorMessages);
  //

  //
  // NOTE: Every time you are about to write a description for the error
  //       message make sure that it sounds natural *both* on it's own
  //       (ex. 'Must be one of {{value}}') AND when prefixed with the
  //       expression 'The service' (ex. 'The service must be one of {{value}}')
  //

  //
  // [A] The following error constants are used by the RAML Validator Loader
  //

  {
    path: /.*/,
    type: "ENUM",
    message: "Must be one of {{values}}"
  },
  {
    path: /.*/,
    type: "ITEMS_MAX",
    message: "Must contain at most {{value}} items in the array"
  },
  {
    path: /.*/,
    type: "ITEMS_MIN",
    message: "Must contain at least {{value}} items in the array"
  },
  {
    path: /.*/,
    type: "ITEMS_UNIQUE",
    message: "Must contain only unique items"
  },
  {
    path: /.*/,
    type: "LENGTH_MAX",
    message: "Must be at most {{value}} characters long"
  },
  {
    path: /.*/,
    type: "LENGTH_MIN",
    message: "Must be at least {{value}} characters long"
  },
  {
    path: /.*/,
    type: "NUMBER_MAX",
    message: "Must be smaller than or equal to {{value}}"
  },
  {
    path: /.*/,
    type: "NUMBER_MIN",
    message: "Must be bigger than or equal to {{value}}"
  },
  {
    path: /.*/,
    type: "NUMBER_MULTIPLEOF",
    message: "Must be multiple of {{value}}"
  },
  {
    path: /.*/,
    type: "NUMBER_TYPE",
    message: "Must be of type `{{type}}`"
  },
  {
    path: /.*/,
    type: "PROPS_MAX",
    message: "Must contain at most {{value}} properties"
  },
  {
    path: /.*/,
    type: "PROPS_MIN",
    message: "Must contain at least {{value}} properties"
  },
  {
    path: /.*/,
    type: "PROP_ADDITIONAL_PROPS",
    message: "Contains extraneous property `{{name}}`"
  },
  {
    path: /.*/,
    type: "PROP_IS_MISSING",
    message: "Must be defined"
  },
  {
    path: /.*/,
    type: "PROP_MISSING",
    message: "Must define property `{{name}}`"
  },
  {
    path: /.*/,
    type: "PROP_MISSING_MATCH",
    message: "Must contain a property that matches `{{pattern}}`"
  },
  {
    path: /.*/,
    type: "STRING_PATTERN",
    message: "Must match the pattern `{{pattern}}`"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_ARRAY",
    message: "Must be an array"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_BOOLEAN",
    message: "Must be a boolean value"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_DATETIME",
    message: "Must be a date/time string"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_INTEGER",
    message: "Must be an integer number"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_NULL",
    message: "Must be null"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_NUMBER",
    message: "Must be a number"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_OBJECT",
    message: "Must be an object"
  },
  {
    path: /.*/,
    type: "TYPE_NOT_STRING",
    message: "Must be a string"
  },

  //
  // [B] The following error constants are generated by parsing the
  //     marathon error messages
  //

  {
    path: /.*/,
    type: "ALREADY_EXISTS",
    message: "Already Exists"
  },

  //
  // [C] Custom Error Messages
  //

  /**
   * Value of a certain shape
   */
  {
    path: /.*/,
    type: "VALUE_SHAPE",
    message: "Must be a certain shape: {{shape}}"
  }
];

module.exports = DefaultErrorMessages;



// WEBPACK FOOTER //
// ./src/js/constants/DefaultErrorMessages.js